<div class="tile__status" data-testid="tile"
    [ngClass]="{ 'tile__status--active': tile.params.workingStatus,
        'tile__status--inactive': !tile.params.workingStatus }">
    <div class="tile__svg--other-wrapper bg-img">
        <img class="tile__svg--other" ngSrc="/assets/img/id_icons/100.svg"
             width="50" height="50" alt="" />
    </div>
    <floating-subtitle class="tile__subtitle"
                       [text]="(subtitle(991)) + ' ' + (tile.params.valveNumber > 0
                        ? tile.params.valveNumber : '')">
    </floating-subtitle>
    <div class="tile__value">
        <p class="tile__value-set-temp font-18 color-default color-default--tile"
           data-testid="set-temp"
           *ngIf="subtitles.downloaded">
           {{ getSetTemp()*10 | format:7 }}
        </p>
        <div class="tile__value-wrapper">
            <p class="tile__value-current font-24 font-bold color-style"
               data-testid="current-temp"
               *ngIf="subtitles.downloaded">
               {{ tile.params.currentTemp | format:7 }}
            </p>
            <img class="tile__actuator-img"
                 ngSrc="/assets/img/icons/actuators_open.svg"
                 width="18" height="18" alt="" />
            <p class=" font-18 color-default color-default--tile"
               data-testid="opening-percentage">
               {{ tile.params.openingPercentage | format:8 }}
            </p>
        </div>
    </div>
    <div class="tile__setting cursor-pointer"
         [ngClass]="{ 'bg-light-shadow': tile.elementMenu.duringChange === 't' }"
         *ngIf="tile.elementMenu && tile.menuId !== 0"
         (click)="openSubmenu()">
        <img ngSrc="/assets/img/icons/{{ getIconName() }}.svg"
             width="30" height="30" alt="" />
        <p class="tile__setting-alert font-12 color-light"
           *ngIf="tile.elementMenu.duringChange === 't'">
            {{ subtitle(3162) }}
        </p>
    </div>
    <div class="hover-area cursor-pointer"
         data-testid="hover-area"
         (click)="openSubmenu()">
    </div>
    <div class="hover bg-dark-shadow box-shadow" data-testid="parameters">
        <div class="hover__item color-light font-12">
            <p class="hover__name">
                {{ subtitle(1161) }}
            </p>
            <p class="hover__value">
               {{ tile.params.openingPercentage | format:8 }}
            </p>
        </div>
        <div class="hover__item color-light font-12"
            *ngIf="tile.params.returnTemp > -200">
            <p class="hover__name">
                {{ subtitle(747) }}
            </p>
            <p class="hover__value">
               {{ tile.params.returnTemp | format:7 }}
            </p>
        </div>
        <div class="hover__item color-light font-12">
            <p class="hover__name">
                {{ subtitle(1066) }}
            </p>
            <p class="hover__value">
               {{ tile.params.setTempCorrection | format:6 }}
            </p>
        </div>
        <div class="hover__item color-light font-12">
            <p class="hover__name">
                {{ subtitle(585) }}
            </p>
            <p class="hover__value">
               {{ tile.params.valvePump === 0 ? subtitle(922) : subtitle(950) }}
            </p>
        </div>
        <div class="hover__item color-light font-12">
            <p class="hover__name">
                {{ subtitle(464) }}
            </p>
            <p class="hover__value">
               {{ tile.params.boilerProtection === 0 ? subtitle(922) : subtitle(950) }}
            </p>
        </div>
        <div class="hover__item color-light font-12">
            <p class="hover__name">
                {{ subtitle(465) }}
            </p>
            <p class="hover__value">
               {{ tile.params.returnProtection === 0 ? subtitle(922) : subtitle(950) }}
            </p>
        </div>
    </div>
</div>
